/**
 * UNavbarCenter is a component to display the content in header after the app title
 */
export default function UNavbarCenter(props) {
  return props.children
}
